export default __webpack_public_path__ + "static/near-collision-desktop-67cb874c254bb36ad9cf4f80db9152eb.png";